// Texnik qo'llab-quvvatlash — xizmat sahifasi kontenti (uz / ru)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "Texnik qo'llab-quvvatlash — sayt va tizimlarni kuzatish, yangilash | Innobek",
        description:
            "Sayt va tizimlarni texnik qo'llab-quvvatlash: 24/7 uptime monitoring, kunlik zaxira nusxa, SSL va domen yangilash, xavfsizlik yangilanishlari. Oyiga 3 500 000 so'mdan.",
        keywords: [
            "texnik qo'llab-quvvatlash",
            "saytni qo'llab-quvvatlash",
            "sayt texnik xizmat",
            "sayt administratori",
            "zaxira nusxa",
            "uptime monitoring",
            "sla javob vaqti",
            "sayt qo'llab-quvvatlash narxi",
        ],
    },

    hero: {
        eyebrow: "Texnik qo'llab-quvvatlash",
        h1: "Texnik qo'llab-quvvatlash: sayt va tizimlaringiz doimiy nazoratda",
        lead:
            "Sayt ishlab turgani — u qarovsiz qolishi mumkin degani emas. Yangilanmagan tizim buziladi, zaxira nusxasi yo'q ma'lumot qaytmaydi, sekinlashgan sayt esa mijozni yo'qotadi. Biz tizimni 24/7 kuzatamiz, har kuni zaxira nusxa olamiz va muammoni siz sezmasingizdan oldin yopamiz.",
        ctaPrimary: "Bepul texnik audit so'rash",
        ctaSecondary: "Tariflarni ko'rish",
        proof: [
            "24/7 uptime monitoring",
            "Kritik nosozlikka 2 soatda javob",
            "Kunlik zaxira nusxa, 30 kun saqlanadi",
            "Boshqa jamoa qurgan tizimlarni ham olamiz",
            "Oylik shart, bir oylik ogohlantirish bilan to'xtatiladi",
        ],
    },

    intro: {
        h: "Texnik qo'llab-quvvatlash nima va u nima uchun kerak?",
        p: [
            "Sayt yoki tizim topshirilgandan keyin ish tugamaydi. Brauzerlar yangilanadi, kutubxonalarda xavfsizlik teshiklari topiladi, hosting sozlamalari o'zgaradi, ma'lumotlar bazasi kattalashadi. Qarovsiz qolgan sayt bir yil ichida sekinlashadi, mobil qurilmalarda buziladi yoki hujumga uchraydi — va bu deyarli har doim eng noqulay paytda ma'lum bo'ladi.",
            "Texnik qo'llab-quvvatlash — bu «biror narsa buzilganda qo'ng'iroq qilish» emas. Bu doimiy kuzatuv: sayt ochilyaptimi, javob vaqti qancha, zaxira nusxa olinyaptimi, yangilanishlar o'rnatildimi, xatolar logida nima bor. Muammolarning katta qismi foydalanuvchi sezmasidan oldin yopiladi.",
            "Innobek o'zi qurgan loyihalarni ham, boshqa jamoa yaratgan tizimlarni ham qo'llab-quvvatlashga oladi. Ikkinchi holatda avval texnik audit o'tkazamiz: kod holati, xavfsizlik, tezlik, zaxira nusxa va hujjatlar tekshiriladi. Audit bepul va u natijasida siz topilgan muammolar ro'yxatini olasiz — biz bilan ishlash yoki ishlamaslikni shundan keyin hal qilasiz.",
            "Javob berish muddati shartnomada raqam bilan yoziladi. Kritik nosozlik — sayt ochilmayapti, to'lov o'tmayapti, admin panelga kirilmayapti — bo'lsa, ish vaqtida 2 soat ichida javob beramiz va darhol ish boshlaymiz. Oddiy so'rov — matn o'zgartirish, yangi sahifa, kichik xato — 24 soat ichida ko'riladi. Kengaytirilgan va SLA tariflarida bu muddatlar qisqaradi.",
            "Nima kirmasligini ham ochiq aytamiz, chunki bu eng ko'p bahs chiqadigan joy. Saytni to'liq qayta loyihalash, yangi katta modul yozish, dizaynni almashtirish, SEO va reklama yuritish, kontent matnini yozish — bular alohida loyiha sifatida hisoblanadi. Hosting va domen to'lovi ham kirmaydi: u provayderga to'g'ridan-to'g'ri to'lanadi, biz faqat texnik boshqaruvni olamiz.",
            "Har oy oxirida hisobot olasiz: nima kuzatilgan, qancha so'rov kelgan va qanchasi yopilgan, qanday yangilanishlar o'rnatilgan, uptime foizi qancha bo'lgan, keyingi oyga qanday tavsiya bor. Bu hujjat siz uchun ham, kelajakdagi boshqa jamoa uchun ham tizim tarixi bo'lib qoladi.",
        ],
    },

    definition: {
        term: "Texnik qo'llab-quvvatlash nima?",
        text:
            "Texnik qo'llab-quvvatlash — sayt yoki tizimning uzluksiz, xavfsiz va tez ishlashini ta'minlash uchun doimiy kuzatuv, zaxiralash, yangilash va tuzatish ishlari. Xizmat oylik shart asosida ishlaydi va javob berish muddatlari shartnomada yoziladi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Xizmatga nimalar kiradi",
        sub: "Quyidagilar barcha tariflarda bor — tarifga qarab hajm va javob muddati farq qiladi.",
        items: [
            "Ishlash holatini 24/7 kuzatish (uptime monitoring), 1 daqiqalik interval",
            "Sayt to'xtaganda avtomatik ogohlantirish — biz birinchi bilib olamiz",
            "Kunlik avtomatik zaxira nusxa: fayllar va ma'lumotlar bazasi",
            "Zaxira nusxalar 30 kun saqlanadi, oylik arxiv 12 oy",
            "Har chorakda zaxiradan tiklashni sinab ko'rish",
            "Xavfsizlik yangilanishlari: CMS, kutubxonalar, server paketlari",
            "SSL sertifikatini kuzatish va avtomatik yangilash",
            "Domen muddatini kuzatish va o'z vaqtida ogohlantirish",
            "Tezlikni o'lchash va PageSpeed ko'rsatkichini kuzatish",
            "Xatolar logini tekshirish va nosozliklarni bartaraf etish",
            "Kontent o'zgarishlari: matn, rasm, narx, xodim, yangilik",
            "Ma'lumotlar bazasini tozalash va optimallashtirish",
            "Hosting va server bo'yicha texnik masalalarni hal qilish",
            "Kirish huquqlarini nazorat qilish va eskirganini bekor qilish",
            "Oylik hisobot: uptime, so'rovlar, yangilanishlar va tavsiyalar",
        ],
    },

    benefits: {
        eyebrow: "Nima beradi",
        h: "Qo'llab-quvvatlash nimadan saqlaydi",
        sub: "Xarajatning katta qismi oldini olish mumkin bo'lgan muammolarga ketadi.",
        items: [
            {
                t: "Sayt to'xtab qolmaydi",
                d: "Monitoring sayt ishlamay qolganini bir necha daqiqada aniqlaydi va bizga xabar yuboradi. Siz emas, biz birinchi bo'lib bilamiz — ko'pincha mijozlar sezmasdan tuzatiladi.",
            },
            {
                t: "Ma'lumot yo'qolmaydi",
                d: "Kunlik zaxira nusxa — eng arzon sug'urta. Server buzilsa yoki xato o'chirish bo'lsa, tizim bir necha soat ichida oxirgi ishlagan holatiga qaytariladi.",
            },
            {
                t: "Xavfsizlik nazoratda",
                d: "Yangilanmagan kutubxonalardagi ma'lum teshiklar hujumchilar uchun ochiq eshik. Yangilanishlar muntazam va sinovdan keyin o'rnatiladi.",
            },
            {
                t: "Tezlik pasaymaydi",
                d: "Vaqt o'tishi bilan rasmlar to'planadi, baza kattalashadi, sahifa sekinlashadi. Bu konversiyaga ham, Google reytingiga ham to'g'ridan-to'g'ri ta'sir qiladi.",
            },
            {
                t: "Javob muddati kafolatlangan",
                d: "«Imkon qadar tez» degan noaniq va'da o'rniga shartnomada raqam turadi: kritik nosozlikka 2 soat, oddiy so'rovga 24 soat.",
            },
            {
                t: "Kontent kutib qolmaydi",
                d: "Narx, aksiya yoki xodim o'zgarganda dasturchi qidirish shart emas. So'rov yuborasiz, o'zgarish kelishilgan muddatda kiritiladi.",
            },
            {
                t: "Bir kishiga bog'liq emassiz",
                d: "Loyihani qurgan dasturchi ketsa ham tizim qarovsiz qolmaydi: kirish huquqlari, hujjatlar va sozlamalar bizda tartibda saqlanadi.",
            },
            {
                t: "Xarajat rejalashtiriladi",
                d: "Oylik summa oldindan ma'lum. Kutilmagan «avariya hisobi» chiqmaydi, chunki muammolarning aksariyati oldindan yopiladi.",
            },
            {
                t: "Tizim tarixi yoziladi",
                d: "Oylik hisobotlar to'planib, tizim hujjatiga aylanadi. Bu keyinchalik boshqa jamoaga topshirishni ancha osonlashtiradi.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlar uchun",
        h: "Qo'llab-quvvatlash kimlarga zarur",
        sub: "Sayt yoki tizim biznes uchun muhim bo'lgan barcha holatlar.",
        items: [
            {
                t: "Sotuv sayt orqali ketadiganlar",
                d: "Internet-do'kon yoki ariza yig'adigan sayt yarim kun ishlamasa — bu to'g'ridan-to'g'ri yo'qotilgan pul va yo'qotilgan mijoz.",
            },
            {
                t: "IT bo'limi yo'q kompaniyalar",
                d: "Sayt bor, unga qaraydigan odam yo'q. Har safar yangi dasturchi qidirish va unga tizimni tushuntirish kerak bo'ladi.",
            },
            {
                t: "Ichki tizim ishlatuvchilar",
                d: "CRM, ERP yoki admin panel to'xtasa, butun bo'lim ishlay olmaydi. Bunday tizimlarga eng qattiq javob muddati kerak.",
            },
            {
                t: "Dasturchisi ketganlar",
                d: "Tizimni kim qurgani noma'lum, hujjat yo'q, parollar yarim yo'qolgan. Biz auditdan boshlaymiz va boshqaruvni tartibga solamiz.",
            },
            {
                t: "Mobil ilova egalari",
                d: "iOS va Android har yili yangilanadi. Muntazam yangilanmagan ilova store talablariga javob bermay qolishi mumkin.",
            },
            {
                t: "Doimiy kontent chiqaruvchilar",
                d: "Yangilik, loyiha yoki mahsulot muntazam qo'shiladi, lekin buni qiladigan odam ichkarida yo'q yoki vaqti yo'q.",
            },
            {
                t: "Shaxsiy ma'lumot bilan ishlovchilar",
                d: "Klinika, ta'lim markazi, moliya xizmati. Bunday tizimda zaxira nusxa va kirish nazorati talab darajasida bo'lishi kerak.",
            },
            {
                t: "Eski saytlar egalari",
                d: "5–7 yillik sayt eskirgan kutubxonalarda ishlaydi. Qo'llab-quvvatlash uni xavfsiz ushlab turadi, redizaynga esa alohida tayyorlanasiz.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "Texnik qo'llab-quvvatlash qancha turadi",
        sub: "Xizmat oylik shart asosida ishlaydi. Quyida uch tarif va ularning farqi.",
        note:
            "Aniq summa bepul texnik auditdan keyin, 2–5 kun ichida beriladi. Narxga ta'sir qiladigan asosiy omillar: tizim turi va hajmi, kunlik tashrif va yuklama, integratsiyalar soni (to'lov, 1C, CRM, SMS, xarita), kontent o'zgarishlari chastotasi, kerakli ishlab chiqish soatlari, javob berish muddati va xavfsizlik talablari. Xizmatga KIRMAYDI: saytni to'liq qayta loyihalash va redizayn, yangi katta modul yoki mobil ilova yozish, SEO va kontekst reklama yuritish, kontent matnini yozish va professional fotosessiya, uchinchi tomon xizmatlari obunasi. Hosting va domen to'lovi ham kirmaydi — ular provayderga to'g'ridan-to'g'ri to'lanadi, biz faqat texnik boshqaruvni olamiz. Shartnoma oylik bo'lib, bir oylik ogohlantirish bilan to'xtatiladi; to'xtatilganda barcha kirish huquqlari, zaxira nusxalar va hujjatlar sizda qoladi. Narxlarga QQS kiritilmagan.",
        tiers: [
            {
                name: "Bazaviy",
                tagline: "Kuzatuv va barqarorlik",
                price: "3 500 000",
                priceNote: "so'm / oyiga",
                term: "Oylik shart",
                best: "Kontenti kam o'zgaradigan vizitka va korporativ saytlar",
                features: [
                    "24/7 uptime monitoring va ogohlantirish",
                    "Kunlik zaxira nusxa, 30 kun saqlash",
                    "Xavfsizlik yangilanishlari va SSL yangilash",
                    "Domen muddatini kuzatish",
                    "Kritik nosozlikka 2 soatda javob (ish vaqtida)",
                    "Oddiy so'rovga 24 soatda javob",
                    "Oyiga 4 soat kontent va kichik tuzatishlar",
                    "Oylik hisobot",
                ],
            },
            {
                name: "Kengaytirilgan",
                tagline: "Qo'llab-quvvatlash va rivojlantirish",
                price: "8 500 000",
                priceNote: "so'm / oyiga",
                term: "Oylik shart",
                best: "Internet-do'kon, faol sayt yoki ichki tizimlar",
                featured: true,
                features: [
                    "Barcha Bazaviy imkoniyatlari",
                    "Oyiga 15 soat ishlab chiqish va o'zgarishlar",
                    "Kritik nosozlikka 1 soatda javob",
                    "Yangi sahifa, bo'lim yoki kichik funksiya qo'shish",
                    "Tezlikni oylik o'lchash va optimallashtirish",
                    "Ma'lumotlar bazasini tozalash va indekslash",
                    "Analitika va konversiya kuzatuvini sozlash",
                    "Choraklik texnik audit va tavsiyalar",
                ],
            },
            {
                name: "SLA",
                tagline: "Kafolatlangan javob va 24/7",
                price: "18 000 000",
                priceNote: "so'mdan / oyiga",
                term: "Yillik shartnoma",
                best: "To'xtashi qimmatga tushadigan tizimlar: do'kon, ERP, ilova",
                features: [
                    "Barcha Kengaytirilgan imkoniyatlari",
                    "Yozma SLA: kritik nosozlikka 30 daqiqada javob, 4 soatda tuzatish",
                    "Dam olish kunlari va bayramlarda ham navbatchilik",
                    "Oyiga 30 soat ishlab chiqish",
                    "Zaxira infratuzilma va tez tiklash rejasi",
                    "Yillik xavfsizlik auditi va kirish huquqlari tekshiruvi",
                    "Shaxsiy texnik menejer va to'g'ridan-to'g'ri aloqa kanali",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "Hamkorlik qanday boshlanadi",
        sub: "Auditdan doimiy xizmatgacha odatda 1–2 hafta.",
        steps: [
            {
                t: "Bepul texnik audit",
                time: "2–5 kun",
                d: "Tizimingizni tekshiramiz: kod holati, xavfsizlik, tezlik, zaxira nusxa va hujjatlar. Topilgan muammolar ro'yxatini majburiyatsiz beramiz.",
            },
            {
                t: "Tarif va shartni belgilash",
                time: "1–2 kun",
                d: "Nima kirishini, oylik soatlarni va javob berish muddatlarini yozma kelishamiz. Aniq oylik summa shu bosqichda beriladi.",
            },
            {
                t: "Tizimni qabul qilish",
                time: "3–5 kun",
                d: "Hosting, domen, repozitoriy va admin panelga kirish huquqlari topshiriladi. Parollar bitta xavfsiz omborga yig'iladi.",
            },
            {
                t: "Monitoring va zaxirani sozlash",
                time: "1–2 kun",
                d: "Uptime kuzatuvi, xatolar logi va avtomatik zaxira nusxa ishga tushiriladi. Tiklash birinchi marta shu bosqichda sinab ko'riladi.",
            },
            {
                t: "Kritik muammolarni yopish",
                time: "1–2 hafta",
                d: "Auditda topilgan xavfsizlik teshiklari, zaxira yo'qligi va tezlik muammolari birinchi navbatda tuzatiladi.",
            },
            {
                t: "Doimiy xizmat",
                time: "davomiy",
                d: "Kuzatuv, yangilanishlar va so'rovlar bo'yicha ish. So'rovlar bitta kanalda qabul qilinadi va navbat bo'yicha yopiladi.",
            },
            {
                t: "Oylik hisobot",
                time: "har oy",
                d: "Uptime foizi, kelgan va yopilgan so'rovlar, o'rnatilgan yangilanishlar va keyingi oyga tavsiyalar bitta hujjatda beriladi.",
            },
            {
                t: "Choraklik ko'rib chiqish",
                time: "3 oyda bir",
                d: "Tizim holati, tezlik va xavfsizlik qayta baholanadi. Kerak bo'lsa tarif yoki soatlar hajmi qayta kelishiladi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz qo'llab-quvvatlaydigan loyihalar",
        sub: "Ishga tushirilgandan keyin ham biz bilan qolgan mijozlar tizimlari — internet-do'kon, logistika platformasi va korporativ saytlar.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["mountain-and-sea", "logistatrans", "global-building-group", "grandpharm", "bobo-market-app"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Texnik qo'llab-quvvatlash bo'yicha eng ko'p so'raladigan savollar va qisqa javoblar.",
        items: [
            {
                q: "Texnik qo'llab-quvvatlash qancha turadi?",
                a: "Bazaviy tarif oyiga 3 500 000 so'mdan boshlanadi — kuzatuv, zaxira nusxa, yangilanishlar va oyiga 4 soat kichik ish. Kengaytirilgan tarif 8 500 000 so'm, unda 15 soat ishlab chiqish bor. SLA tarifi 18 000 000 so'mdan, kafolatlangan javob muddati bilan. Aniq summa bepul auditdan keyin beriladi.",
            },
            {
                q: "Shoshilinch muammoda qancha vaqtda javob berasiz?",
                a: "Bazaviy tarifda kritik nosozlikka ish vaqtida 2 soat ichida javob beramiz, oddiy so'rovga 24 soat ichida. Kengaytirilgan tarifda kritik javob 1 soatga qisqaradi. SLA shartnomasida esa 30 daqiqada javob va 4 soatda tuzatish yozma kafolatlanadi, dam olish kunlarida ham navbatchilik bo'ladi.",
            },
            {
                q: "Xizmatga aniq nimalar kiradi?",
                a: "Barcha tariflarda: 24/7 uptime monitoring, kunlik zaxira nusxa, xavfsizlik yangilanishlari, SSL va domen kuzatuvi, tezlikni o'lchash, xatolarni tuzatish, kontent o'zgarishlari va oylik hisobot. Kengaytirilgan va SLA tariflarida ustiga oylik ishlab chiqish soatlari qo'shiladi — ulardan yangi sahifa yoki funksiya uchun foydalanasiz.",
            },
            {
                q: "Nima kirmaydi?",
                a: "Saytni to'liq qayta loyihalash va redizayn, katta yangi modul yoki mobil ilova yozish, SEO va reklama yuritish, kontent matnini yozish, professional fotosessiya va uchinchi tomon xizmatlari obunasi. Hosting va domen to'lovi ham kirmaydi — ular provayderga to'g'ridan-to'g'ri to'lanadi. Bunday ishlar alohida loyiha sifatida hisoblanadi.",
            },
            {
                q: "Zaxira nusxa qanchalik tez-tez olinadi?",
                a: "Har kuni avtomatik tarzda: fayllar va ma'lumotlar bazasi alohida olinadi. Nusxalar 30 kun saqlanadi, oylik arxiv esa 12 oy davomida turadi. Faol internet-do'konlar uchun kuniga ikki marta yoki soatlik zaxira sozlanadi. Har chorakda tiklashni amalda sinab ko'ramiz — tekshirilmagan zaxira nusxa ishonchli hisoblanmaydi.",
            },
            {
                q: "Saytimni boshqa kompaniya qurgan — olasizmi?",
                a: "Ha, bu bizda odatiy holat. Avval bepul texnik audit o'tkazamiz: kod holati, xavfsizlik, tezlik, zaxira nusxa va hujjatlar tekshiriladi. Agar tizim juda eskirgan bo'lsa yoki kod holati xavfli bo'lsa, buni ochiq aytamiz va qo'llab-quvvatlash o'rniga yangilash foydaliroq ekanini raqamlar bilan asoslab beramiz.",
            },
            {
                q: "SSL va domen yangilanishini siz qilasizmi?",
                a: "Ha. SSL sertifikati muddati doimiy kuzatiladi va avtomatik yangilanadi; agar avtomatik yangilanish ishlamasa, sertifikatni qo'lda o'rnatamiz. Domen muddati ham nazoratda: tugashiga bir oy qolganda ogohlantiramiz va yangilash jarayonini texnik tomondan to'liq olib boramiz. Domen to'lovining o'zi registratorga siz tomondan to'lanadi.",
            },
            {
                q: "Uptime monitoring qanday ishlaydi?",
                a: "Sayt har daqiqada bir necha nuqtadan tekshiriladi. Javob kelmasa yoki xato kodi qaytsa, navbatchi mutaxassisga darhol xabar boradi. Oylik hisobotda uptime foizi va har bir uzilishning sababi ko'rsatiladi. Server resurslari — protsessor, xotira, disk — ham kuzatiladi va to'lishidan oldin ogohlantiriladi.",
            },
            {
                q: "Shartnomani istalgan vaqtda to'xtatsam bo'ladimi?",
                a: "Ha. Oylik shartnoma bir oylik ogohlantirish bilan to'xtatiladi, jarima yoki yashirin to'lov yo'q. SLA shartnomasi odatda yillik bo'ladi va uning to'xtatish shartlari alohida kelishiladi. To'xtatilganda barcha kirish huquqlari, oxirgi zaxira nusxalar va texnik hujjatlar sizga rasman topshiriladi — hech narsa bloklanmaydi.",
            },
            {
                q: "Bepul audit haqiqatan bepulmi?",
                a: "Ha. Audit 2–5 kun oladi va uning natijasi — topilgan muammolar ro'yxati, ularning xavflilik darajasi va aniq tavsiyalar — sizga hech qanday majburiyatsiz beriladi. Tayyor hujjatni istagan boshqa dasturchingizga ko'rsatib tekshirtirishingiz mumkin. Biz bilan ishlash yoki ishlamaslikni shundan keyin hal qilasiz.",
            },
        ],
    },

    cta: {
        h: "Tizimingizni tekshirib ko'ramizmi?",
        p: "Bepul texnik auditda saytingiz yoki tizimingizning holatini tekshiramiz, xavfli joylarni ko'rsatamiz va aniq oylik hisob-kitob beramiz. Majburiyat yo'q. Qo'ng'iroq: +998 90 954 12 62.",
        button: "Bepul audit so'rash",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-hero.webp",
            alt: "Texnik qo'llab-quvvatlash: server va sayt holatini kuzatish paneli monitorda",
            caption: "Tizim 24/7 kuzatuvda — sayt to'xtasa, biz birinchi bo'lib bilamiz.",
            prompt:
                "Wide hero image of a monitoring workstation: two large screens showing server dashboards with uptime graphs, response-time charts and green status indicators. Dark UI with teal and amber accents, dim office at night, one engineer silhouetted from behind, no visible face, no readable logos. Photographic, 16:9, calm and technical.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-backup.webp",
            alt: "Kunlik zaxira nusxa va tiklash jarayoni: fayllar va ma'lumotlar bazasi arxivi",
            caption: "Kunlik zaxira nusxa 30 kun saqlanadi, tiklash har chorakda sinab ko'riladi.",
            prompt:
                "Clean flat illustration of an automated backup pipeline: a server icon on the left, daily snapshot blocks in the middle arranged on a timeline, and a restore arrow pointing back. Muted blue and green palette, thin outlines, generous white space, documentation-diagram look. Vector style, 16:9.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-sla.webp",
            alt: "SLA javob vaqti: kritik nosozlikka 2 soat, oddiy so'rovga 24 soat",
            caption: "Javob muddati shartnomada raqam bilan yoziladi, «imkon qadar tez» emas.",
            prompt:
                "Minimal infographic showing service level tiers as three horizontal lanes with clock icons and time markers: critical, high and normal priority. Muted red, amber and blue accents on a light neutral canvas, thin lines, plenty of spacing, no text that must be readable. Flat vector, 16:9.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-security.webp",
            alt: "Xavfsizlik yangilanishlari, SSL sertifikati va kirish huquqlari nazorati",
            caption: "Yangilanmagan kutubxona — hujumchilar uchun ochiq eshik. Yangilanishlar muntazam o'rnatiladi.",
            prompt:
                "Abstract security maintenance illustration: a padlock with an SSL certificate badge, a package-update list with version numbers, and an access-control key list, arranged as clean cards on a neutral canvas. Muted blue and slate palette, thin outlines, subtle shadow. Flat vector, 16:9.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-report.webp",
            alt: "Oylik hisobot: uptime foizi, yopilgan so'rovlar va o'rnatilgan yangilanishlar",
            caption: "Har oy oxirida bitta hujjat: nima kuzatilgan, nima tuzatilgan, keyingi oyda nima kerak.",
            prompt:
                "A monthly service report page shown on a tablet: uptime percentage as a large number, a simple bar chart of resolved tickets, a list of applied updates and a short recommendations block. Light theme, muted blue accents, clean typography blocks without readable text, soft desk background. Photographic with screen detail, 16:9.",
        },
    ],

    related: ["it-autsorsing", "korporativ-saytlar", "internet-dokonlar", "veb-ilovalar"],
};

const ru = {
    meta: {
        title: "Техническая поддержка сайтов и систем — мониторинг, обновления | Innobek",
        description:
            "Техподдержка сайтов и систем: мониторинг 24/7, ежедневные бэкапы, продление SSL и домена, обновления безопасности, месячный отчёт. От 3 500 000 сум в месяц.",
        keywords: [
            "техническая поддержка сайта",
            "поддержка сайта",
            "техподдержка сайтов",
            "администрирование сайта",
            "резервное копирование",
            "мониторинг доступности",
            "sla время реакции",
            "стоимость поддержки сайта",
        ],
    },

    hero: {
        eyebrow: "Техническая поддержка",
        h1: "Техническая поддержка: сайт и системы под постоянным контролем",
        lead:
            "То, что сайт работает, не значит, что за ним не нужно следить. Необновлённая система ломается, данные без резервной копии не восстановить, а медленный сайт теряет клиентов. Мы наблюдаем за системой 24/7, ежедневно делаем бэкап и закрываем проблемы до того, как вы их заметите.",
        ctaPrimary: "Запросить бесплатный аудит",
        ctaSecondary: "Посмотреть тарифы",
        proof: [
            "Мониторинг доступности 24/7",
            "Реакция на критичный сбой — 2 часа",
            "Ежедневный бэкап, хранение 30 дней",
            "Берём системы, сделанные другой командой",
            "Помесячно, расторжение — с уведомлением за месяц",
        ],
    },

    intro: {
        h: "Что такое техническая поддержка и зачем она нужна",
        p: [
            "После сдачи сайта или системы работа не заканчивается. Браузеры обновляются, в библиотеках находят уязвимости, настройки хостинга меняются, база данных растёт. Оставленный без присмотра сайт за год замедляется, ломается на телефонах или становится целью атаки — и выясняется это почти всегда в самый неудобный момент.",
            "Техподдержка — это не «позвонить, когда всё сломалось». Это постоянное наблюдение: открывается ли сайт, какое время ответа, снимается ли резервная копия, установлены ли обновления, что лежит в логе ошибок. Большая часть проблем закрывается до того, как их заметит пользователь.",
            "Innobek берёт на поддержку и собственные проекты, и системы, сделанные другой командой. Во втором случае сначала проводим технический аудит: состояние кода, безопасность, скорость, бэкапы и документация. Аудит бесплатный, по его итогам вы получаете список найденных проблем — работать с нами или нет, решаете уже после этого.",
            "Время реакции фиксируется в договоре цифрой. Критичный сбой — сайт не открывается, не проходит оплата, недоступна админка — мы берём в работу в течение 2 часов в рабочее время. Обычный запрос — правка текста, новая страница, мелкая ошибка — рассматривается в течение 24 часов. В тарифах «Расширенный» и SLA эти сроки короче.",
            "Сразу говорим, что НЕ входит: именно здесь чаще всего возникают споры. Полная переделка сайта, новый крупный модуль, смена дизайна, ведение SEO и рекламы, написание текстов — всё это считается отдельным проектом. Оплата хостинга и домена тоже не входит: она идёт напрямую провайдеру, мы берём на себя только техническое управление.",
            "В конце каждого месяца вы получаете отчёт: что наблюдалось, сколько запросов пришло и сколько закрыто, какие обновления установлены, какой получился процент доступности и что рекомендуется на следующий месяц. Этот документ со временем становится историей системы — и для вас, и для любой будущей команды.",
        ],
    },

    definition: {
        term: "Что такое техническая поддержка сайта?",
        text:
            "Техническая поддержка — это постоянное наблюдение, резервное копирование, обновление и исправление, которые обеспечивают бесперебойную, безопасную и быструю работу сайта или системы. Услуга работает помесячно, а сроки реакции фиксируются в договоре.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Что входит в услугу",
        sub: "Это есть во всех тарифах — различаются объём и сроки реакции.",
        items: [
            "Мониторинг доступности 24/7 с интервалом в одну минуту",
            "Автоматическое оповещение при падении — мы узнаём первыми",
            "Ежедневный бэкап: файлы и база данных отдельно",
            "Хранение копий 30 дней, месячный архив — 12 месяцев",
            "Ежеквартальная проверка восстановления из резервной копии",
            "Обновления безопасности: CMS, библиотеки, пакеты сервера",
            "Контроль и автоматическое продление SSL-сертификата",
            "Контроль срока домена и заблаговременное предупреждение",
            "Замеры скорости и отслеживание показателей PageSpeed",
            "Разбор логов ошибок и устранение сбоев",
            "Изменения контента: тексты, фото, цены, сотрудники, новости",
            "Очистка и оптимизация базы данных",
            "Решение технических вопросов по хостингу и серверу",
            "Контроль доступов и отзыв устаревших учётных записей",
            "Месячный отчёт: доступность, запросы, обновления, рекомендации",
        ],
    },

    benefits: {
        eyebrow: "Что это даёт",
        h: "От чего защищает поддержка",
        sub: "Большая часть расходов приходится на проблемы, которых можно было избежать.",
        items: [
            {
                t: "Сайт не простаивает",
                d: "Мониторинг фиксирует падение за считаные минуты и сразу оповещает нас. Вы узнаёте о проблеме не от клиентов — чаще всего её успевают починить раньше.",
            },
            {
                t: "Данные не теряются",
                d: "Ежедневный бэкап — самая дешёвая страховка. При сбое сервера или ошибочном удалении система возвращается к последнему рабочему состоянию за несколько часов.",
            },
            {
                t: "Безопасность под контролем",
                d: "Известные уязвимости в необновлённых библиотеках — открытая дверь для атак. Обновления ставятся регулярно и после проверки на тестовой среде.",
            },
            {
                t: "Скорость не падает",
                d: "Со временем накапливаются изображения, растёт база, страницы тормозят. Это бьёт и по конверсии, и по позициям в Google.",
            },
            {
                t: "Время реакции гарантировано",
                d: "Вместо расплывчатого «как можно быстрее» в договоре стоит цифра: 2 часа на критичный сбой и 24 часа на обычный запрос.",
            },
            {
                t: "Контент не ждёт очереди",
                d: "При смене цены, акции или сотрудника не нужно искать разработчика. Вы отправляете запрос, правка вносится в согласованный срок.",
            },
            {
                t: "Вы не зависите от одного человека",
                d: "Даже если разработчик проекта ушёл, система не останется без присмотра: доступы, документация и настройки хранятся у нас в порядке.",
            },
            {
                t: "Расходы планируются",
                d: "Месячная сумма известна заранее. Неожиданный «аварийный счёт» не появляется, потому что большая часть проблем закрывается превентивно.",
            },
            {
                t: "История системы фиксируется",
                d: "Месячные отчёты накапливаются и превращаются в документацию. Это заметно упрощает передачу проекта другой команде.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Кому нужна техническая поддержка",
        sub: "Случаи, когда сайт или система важны для бизнеса.",
        items: [
            {
                t: "Продажи идут через сайт",
                d: "Если интернет-магазин или форма заявок не работают полдня — это прямые потери денег и ушедшие к конкуренту клиенты.",
            },
            {
                t: "Компании без IT-отдела",
                d: "Сайт есть, а следить за ним некому. Каждый раз приходится искать разработчика и заново объяснять ему систему.",
            },
            {
                t: "Пользователи внутренних систем",
                d: "Если CRM, ERP или админ-панель встали, не работает целый отдел. Таким системам нужны самые жёсткие сроки реакции.",
            },
            {
                t: "Проекты без прежнего разработчика",
                d: "Кто собрал систему — неизвестно, документации нет, часть паролей утеряна. Начинаем с аудита и наводим порядок в доступах.",
            },
            {
                t: "Владельцы мобильных приложений",
                d: "iOS и Android обновляются ежегодно. Приложение без регулярных обновлений перестаёт соответствовать требованиям магазинов приложений.",
            },
            {
                t: "Те, кто часто обновляет контент",
                d: "Новости, проекты или товары добавляются постоянно, но внутри компании этим заниматься некому.",
            },
            {
                t: "Работа с персональными данными",
                d: "Клиника, учебный центр, финансовый сервис. Здесь бэкапы и контроль доступов должны отвечать повышенным требованиям.",
            },
            {
                t: "Владельцы старых сайтов",
                d: "Сайту 5–7 лет, он работает на устаревших библиотеках. Поддержка держит его в безопасности, пока вы готовитесь к редизайну.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Сколько стоит техническая поддержка",
        sub: "Услуга работает помесячно. Ниже три тарифа и разница между ними.",
        note:
            "Точную сумму называем после бесплатного технического аудита, в течение 2–5 дней. На цену влияют: тип и размер системы, посещаемость и нагрузка, число интеграций (оплата, 1С, CRM, SMS, карты), частота изменений контента, нужный объём часов разработки, сроки реакции и требования безопасности. НЕ ВХОДИТ: полная переделка и редизайн сайта, новый крупный модуль или мобильное приложение, ведение SEO и контекстной рекламы, написание текстов и профессиональная фотосъёмка, подписки сторонних сервисов. Оплата хостинга и домена тоже не входит — она идёт напрямую провайдеру, мы берём только техническое управление. Договор помесячный и прекращается с уведомлением за месяц; при прекращении все доступы, резервные копии и документация остаются у вас. Цены указаны без НДС.",
        tiers: [
            {
                name: "Базовый",
                tagline: "Наблюдение и стабильность",
                price: "3 500 000",
                priceNote: "сум / месяц",
                term: "Помесячно",
                best: "Сайтам-визиткам и корпоративным сайтам с редкими правками",
                features: [
                    "Мониторинг доступности 24/7 с оповещениями",
                    "Ежедневный бэкап, хранение 30 дней",
                    "Обновления безопасности и продление SSL",
                    "Контроль срока домена",
                    "Реакция на критичный сбой — 2 часа в рабочее время",
                    "Реакция на обычный запрос — 24 часа",
                    "4 часа в месяц на контент и мелкие правки",
                    "Месячный отчёт",
                ],
            },
            {
                name: "Расширенный",
                tagline: "Поддержка и развитие",
                price: "8 500 000",
                priceNote: "сум / месяц",
                term: "Помесячно",
                best: "Интернет-магазинам, активным сайтам и внутренним системам",
                featured: true,
                features: [
                    "Всё из тарифа «Базовый»",
                    "15 часов разработки и доработок в месяц",
                    "Реакция на критичный сбой — 1 час",
                    "Новые страницы, разделы и небольшие функции",
                    "Ежемесячные замеры скорости и оптимизация",
                    "Очистка базы данных и настройка индексов",
                    "Настройка аналитики и отслеживания конверсий",
                    "Ежеквартальный технический аудит с рекомендациями",
                ],
            },
            {
                name: "SLA",
                tagline: "Гарантированная реакция и режим 24/7",
                price: "18 000 000",
                priceNote: "сум / месяц, от",
                term: "Годовой договор",
                best: "Системам, простой которых обходится дорого: магазин, ERP, приложение",
                features: [
                    "Всё из тарифа «Расширенный»",
                    "Письменный SLA: реакция 30 минут, устранение 4 часа",
                    "Дежурство в выходные и праздничные дни",
                    "30 часов разработки в месяц",
                    "Резервная инфраструктура и план быстрого восстановления",
                    "Ежегодный аудит безопасности и ревизия доступов",
                    "Персональный технический менеджер и прямой канал связи",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как начинается сотрудничество",
        sub: "От аудита до постоянного обслуживания обычно проходит 1–2 недели.",
        steps: [
            {
                t: "Бесплатный технический аудит",
                time: "2–5 дней",
                d: "Проверяем систему: состояние кода, безопасность, скорость, бэкапы и документацию. Список найденных проблем отдаём без обязательств.",
            },
            {
                t: "Выбор тарифа и условий",
                time: "1–2 дня",
                d: "Письменно согласуем состав работ, объём часов и сроки реакции. Точную месячную сумму называем на этом шаге.",
            },
            {
                t: "Приём системы",
                time: "3–5 дней",
                d: "Передаются доступы к хостингу, домену, репозиторию и админ-панели. Пароли собираются в одно защищённое хранилище.",
            },
            {
                t: "Настройка мониторинга и бэкапов",
                time: "1–2 дня",
                d: "Запускаем отслеживание доступности, сбор логов и автоматическое резервное копирование. Восстановление проверяем сразу же.",
            },
            {
                t: "Закрытие критичных проблем",
                time: "1–2 недели",
                d: "В первую очередь устраняем найденные при аудите уязвимости, отсутствие бэкапов и проблемы со скоростью.",
            },
            {
                t: "Постоянное обслуживание",
                time: "постоянно",
                d: "Наблюдение, обновления и работа по запросам. Запросы принимаются в одном канале и закрываются по очереди и приоритету.",
            },
            {
                t: "Месячный отчёт",
                time: "каждый месяц",
                d: "Процент доступности, принятые и закрытые запросы, установленные обновления и рекомендации на следующий месяц.",
            },
            {
                t: "Ежеквартальный пересмотр",
                time: "раз в 3 месяца",
                d: "Заново оцениваем состояние системы, скорость и безопасность. При необходимости пересогласуем тариф или объём часов.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Проекты, которые мы поддерживаем",
        sub: "Системы клиентов, оставшихся с нами после запуска: магазины, логистика и корпоративные сайты.",
        cta: "Смотреть все проекты",
        slugs: ["mountain-and-sea", "logistatrans", "global-building-group", "grandpharm", "bobo-market-app"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Коротко отвечаем на частые вопросы о техподдержке.",
        items: [
            {
                q: "Сколько стоит техническая поддержка сайта?",
                a: "Базовый тариф — от 3 500 000 сум в месяц: мониторинг, бэкапы, обновления и 4 часа мелких работ. Расширенный — 8 500 000 сум, в нём 15 часов разработки. Тариф SLA — от 18 000 000 сум с гарантированными сроками реакции. Точную сумму называем после бесплатного технического аудита.",
            },
            {
                q: "Как быстро вы реагируете на срочную проблему?",
                a: "В базовом тарифе критичный сбой берём в работу в течение 2 часов в рабочее время, обычный запрос — в течение 24 часов. В расширенном тарифе реакция на критичный сбой сокращается до 1 часа. В договоре SLA письменно гарантируются 30 минут на реакцию и 4 часа на устранение, включая выходные.",
            },
            {
                q: "Что именно входит в услугу?",
                a: "Во всех тарифах: мониторинг доступности 24/7, ежедневные бэкапы, обновления безопасности, контроль SSL и домена, замеры скорости, устранение ошибок, изменения контента и месячный отчёт. В расширенном тарифе и SLA добавляются часы разработки — их можно тратить на новые страницы, разделы или функции.",
            },
            {
                q: "Что не входит?",
                a: "Полная переделка и редизайн сайта, новый крупный модуль или мобильное приложение, ведение SEO и контекстной рекламы, написание текстов, профессиональная фотосъёмка и подписки сторонних сервисов. Оплата хостинга и домена тоже не входит — она идёт напрямую провайдеру. Такие работы считаются отдельным проектом со своей сметой.",
            },
            {
                q: "Как часто делаются резервные копии?",
                a: "Ежедневно и автоматически: файлы и база данных снимаются отдельно. Копии хранятся 30 дней, месячный архив — 12 месяцев. Для активных интернет-магазинов настраиваем бэкап дважды в сутки или почасовой. Раз в квартал проверяем восстановление на практике: непроверенная резервная копия надёжной не считается.",
            },
            {
                q: "Наш сайт делала другая компания — возьмёте?",
                a: "Да, это обычная для нас ситуация. Сначала проводим бесплатный технический аудит: смотрим состояние кода, безопасность, скорость, бэкапы и документацию. Если система сильно устарела или код небезопасен, честно скажем об этом и на цифрах покажем, почему обновление выгоднее поддержки.",
            },
            {
                q: "Вы продлеваете SSL и домен?",
                a: "Да. Срок SSL-сертификата постоянно отслеживается, продление идёт автоматически, а если автопродление не срабатывает — ставим сертификат вручную. Срок домена тоже под контролем: предупреждаем за месяц до окончания и полностью ведём продление с технической стороны. Платёж регистратору вы проводите самостоятельно.",
            },
            {
                q: "Как работает мониторинг доступности?",
                a: "Сайт проверяется каждую минуту с нескольких географических точек. Если ответа нет или возвращается код ошибки, дежурному специалисту сразу уходит оповещение. В месячном отчёте показываем процент доступности и причину каждого сбоя. Ресурсы сервера — процессор, память и диск — тоже отслеживаются, и система заранее предупреждает о заполнении.",
            },
            {
                q: "Можно прекратить договор в любой момент?",
                a: "Да. Помесячный договор прекращается с уведомлением за месяц, без штрафов и скрытых платежей. Договор SLA обычно годовой, условия его расторжения согласуются отдельно. При прекращении мы официально передаём все доступы, последние резервные копии и техническую документацию — ничего не блокируется и не удерживается.",
            },
            {
                q: "Аудит правда бесплатный?",
                a: "Да. Аудит занимает 2–5 дней, а его результат — список найденных проблем, оценка их критичности и конкретные рекомендации — вы получаете без каких-либо обязательств. Готовый документ можно показать своему разработчику для проверки. Работать с нами или нет, решаете уже после этого.",
            },
        ],
    },

    cta: {
        h: "Проверим состояние вашей системы?",
        p: "На бесплатном техническом аудите проверим сайт или систему, покажем уязвимые места и дадим точный месячный расчёт. Без обязательств. Звоните: +998 90 954 12 62.",
        button: "Запросить бесплатный аудит",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-hero.webp",
            alt: "Техническая поддержка: панель мониторинга состояния сервера и сайта на мониторе",
            caption: "Система под наблюдением 24/7 — о падении сайта мы узнаём первыми.",
            prompt:
                "Wide hero image of a monitoring workstation: two large screens showing server dashboards with uptime graphs, response-time charts and green status indicators. Dark UI with teal and amber accents, dim office at night, one engineer silhouetted from behind, no visible face, no readable logos. Photographic, 16:9, calm and technical.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-backup.webp",
            alt: "Ежедневное резервное копирование и восстановление: архив файлов и базы данных",
            caption: "Ежедневные копии хранятся 30 дней, восстановление проверяется каждый квартал.",
            prompt:
                "Clean flat illustration of an automated backup pipeline: a server icon on the left, daily snapshot blocks in the middle arranged on a timeline, and a restore arrow pointing back. Muted blue and green palette, thin outlines, generous white space, documentation-diagram look. Vector style, 16:9.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-sla.webp",
            alt: "Время реакции по SLA: 2 часа на критичный сбой и 24 часа на обычный запрос",
            caption: "Срок реакции записан в договоре цифрой, а не формулировкой «как можно быстрее».",
            prompt:
                "Minimal infographic showing service level tiers as three horizontal lanes with clock icons and time markers: critical, high and normal priority. Muted red, amber and blue accents on a light neutral canvas, thin lines, plenty of spacing, no text that must be readable. Flat vector, 16:9.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-security.webp",
            alt: "Обновления безопасности, SSL-сертификат и контроль прав доступа",
            caption: "Необновлённая библиотека — открытая дверь для атаки. Обновления ставятся регулярно.",
            prompt:
                "Abstract security maintenance illustration: a padlock with an SSL certificate badge, a package-update list with version numbers, and an access-control key list, arranged as clean cards on a neutral canvas. Muted blue and slate palette, thin outlines, subtle shadow. Flat vector, 16:9.",
        },
        {
            src: "/assets/img/services/texnik-qollab-quvvatlash-report.webp",
            alt: "Месячный отчёт: процент доступности, закрытые запросы и установленные обновления",
            caption: "Раз в месяц один документ: что наблюдалось, что исправлено, что нужно дальше.",
            prompt:
                "A monthly service report page shown on a tablet: uptime percentage as a large number, a simple bar chart of resolved tickets, a list of applied updates and a short recommendations block. Light theme, muted blue accents, clean typography blocks without readable text, soft desk background. Photographic with screen detail, 16:9.",
        },
    ],

    related: ["it-autsorsing", "korporativ-saytlar", "internet-dokonlar", "veb-ilovalar"],
};

const content = { uz, ru };

export default content;
